import React from 'react';
import { Col } from 'shards-react';
import AlertMessage from '../AlertMessage';

/**
 * Export a component that contain all input fields
 * with extracted data.
 */

const Toolbar = ({ children = <AlertMessage alertMessage={'Der Werkzeugkasten konnte nicht erstellt werden, da kein Template für diesen Service existiert!'} /> }) => {
	return <Col className='modal-toolbar bg-light p-3 border-left h-100 overflow-auto scrollbar'>{children}</Col>;
};

export default Toolbar;
